import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../../common/useFormatter';
import useAssignmentMetricDescriptorsMap from '../assignment/useAssignmentMetricDescriptors';
import useItemSetMetricDescriptorsMap from '../itemSet/useItemSetMetricDescriptors';
import useItemStatsMetricDescriptorsMap from '../itemStats/useItemStatsMetricDescriptors';
import useLocationMetricDescriptorsMap from '../location/useLocationMetricDescriptors';
import { getSimulationHqMetricDescriptorsMap } from './simulationHqMetric.default';
import { SimulationHqMetricDescriptor } from './simulationHqMetric.types';

function useSimulationHqMetricDescriptorsMap() {
  const { t } = useTranslation('feed');
  const formatter = useFormatter();

  const itemSetMetricDescriptorsMap = useItemSetMetricDescriptorsMap();
  const itemStatsMetricDescriptorsMap = useItemStatsMetricDescriptorsMap();
  const locationMetricDescriptorsMap = useLocationMetricDescriptorsMap();
  const assignmentMetricDescriptorsMap = useAssignmentMetricDescriptorsMap();
  // const extraDescriptors = useRecoilValue(actualityExtraMetricDescriptors);

  const metrics: SimulationHqMetricDescriptor[] = [
    ..._.values(itemSetMetricDescriptorsMap),
    ..._.values(itemStatsMetricDescriptorsMap),
    ..._.values(assignmentMetricDescriptorsMap),
    ..._.values(locationMetricDescriptorsMap),
    {
      ...getSimulationHqMetricDescriptorsMap(t).stockUomHeight,
      category: 'stockUom',
      titleCategory: t(`Stock Stats`, { ns: 'simulation' }),
      title: t('Stock UOM Height', { ns: 'simulation' }),
      subTitle: t('Item', { ns: 'simulation' }),
      format: v => formatter.formatDistance(v, 10).fullString,
    },

    {
      ...getSimulationHqMetricDescriptorsMap(t).stockUomNetWeight,
      category: 'stockUom',
      titleCategory: t(`Stock Stats`, { ns: 'simulation' }),
      title: t('Stock UOM Weight', { ns: 'simulation' }),
      subTitle: t('Item', { ns: 'simulation' }),
      format: v => formatter.formatWeight(v, 10).fullString,
    },
    {
      ...getSimulationHqMetricDescriptorsMap(t).stockUomVolume,
      category: 'stockUom',
      titleCategory: t(t`Stock Stats`, { ns: 'simulation' }),
      title: t('Stock UOM Volume', { ns: 'simulation' }),
      subTitle: t('Item', { ns: 'simulation' }),
      format: v => formatter.formatVolume(v).fullString,
    },
    {
      ...getSimulationHqMetricDescriptorsMap(t).stockUomMaxStack,
      category: 'stockUom',
      titleCategory: t(t`Stock Stats`, { ns: 'simulation' }),
      title: t('Stock UOM Max Stackability', { ns: 'simulation' }),
      subTitle: t('Item', { ns: 'simulation' }),
      format: v => formatter.formatInteger(v).fullString,
    },

    // ...(extraDescriptors as any),
  ];

  return _.keyBy(metrics, d => d.type);
}

export default useSimulationHqMetricDescriptorsMap;
